<template>
    <div class="d-flex flex-column align-center justify-center" style="height: 100vh">
        <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
        ></v-progress-circular>
        <span>Loading....</span>
    </div>
</template>

<script>
    export default {
        name: "AppLoading"
    }
</script>

<style scoped>

</style>